import { replaceUrlPlaceholders } from "react-utils";
import axiosCoralie from "../axios-setup";
import { emptyObject } from "../utils/formUtils";
import { addQueryToUrl } from "../utils/urlUtils";

const CONF = window?.confPub;
const GESTION_ROUTES = CONF?.ROUTES?.GESTION

export const validationNir = async (nir) => {

    const VALIDATION_NIR = GESTION_ROUTES?.VALIDATION_NIR

    const urlWithNir = replaceUrlPlaceholders(VALIDATION_NIR, { nir: nir })

    try {
        const resp = await axiosCoralie.get(urlWithNir)

        emptyObject(resp?.data)

        if (!emptyObject(resp?.data)) {

            return resp?.data
        } else {

            return null
        }

    } catch (err) {

        console.error('Erreur lors de l\'envoi des données', err);
        // alert('Échec de l\'envoi des données');
        throw err;
    }
}

export const getReferences = async () => {

    const REFERENCES = GESTION_ROUTES?.REFERENCES

    try {
        const resp = await axiosCoralie.get(REFERENCES)

        console.log("resp")
        console.log(resp)

        emptyObject(resp?.data)

        if (!emptyObject(resp?.data)) {

            return resp?.data
        } else {

            return null
        }

    } catch (err) {

        console.error('Erreur lors de l\'envoi des données', err);
        // alert('Échec de l\'envoi des données');
        throw err;
    }
}